module.exports = __webpack_public_path__ + "bfa5b7beba080b0c6af53ca5a255b37d.woff";